import React from "react";
import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "1. Who we are",
    paragraphs: [
      "Wishing Wellness (\"we,\" \"us,\" or \"our\") operates the website at wishingwellnesslife.com and related properties, and publishes The Strong Force Daily. This Privacy Policy explains what information we collect, how we use it, and the choices you have.",
      "By using our website or subscribing to our email list, you agree to this Privacy Policy. If you do not agree, please do not use our services.",
    ],
  },
  {
    heading: "2. Information we collect",
    paragraphs: [
      "We collect only the information you choose to give us and a small amount of technical information automatically collected when you visit our website.",
    ],
    list: [
      "Information you give us: your first name, email address, and any message you send through our contact or newsletter forms.",
      "Purchase intent: when you tap \"Notify Me\" on a paid product, we record which product you were interested in so we can email you when it launches.",
      "Automatic technical information: standard log data (browser type, device type, IP address, referring page) and privacy-friendly analytics via PostHog to understand how the site is used.",
      "Cookies: we use a small number of essential cookies for the site to function, and analytics cookies (which you can block in your browser).",
    ],
  },
  {
    heading: "3. How we use your information",
    list: [
      "To send you the free 7-Day Discipline Challenge and the weekly Wishing Wellness newsletter.",
      "To respond to messages you send us.",
      "To notify you when a paid product (such as the 30-Day or 90-Day Discipline Journal) becomes available.",
      "To understand which pages and offers are helpful so we can improve the site.",
      "To protect the site from abuse, fraud, and technical issues.",
    ],
  },
  {
    heading: "4. Email sending",
    paragraphs: [
      "We use a transactional email provider (Resend, routed through Emergent's managed integration) to deliver welcome emails and newsletters. Your email address is shared only with the email provider for the purpose of delivering messages.",
      "You can unsubscribe from any newsletter email at any time using the link in that email. Unsubscribing does not delete your account or any past purchases.",
    ],
  },
  {
    heading: "5. Payment information",
    paragraphs: [
      "Paid products are not yet available for purchase. When checkout launches, payments will be processed by a PCI-compliant third-party payment processor. We will not store your card number or full payment details on our servers.",
    ],
  },
  {
    heading: "6. Sharing your information",
    paragraphs: [
      "We do not sell your personal information. We share it only with service providers who help us run our business — for example, our email provider, hosting provider, and (in the future) payment processor. Those providers may only use your information to perform services for us.",
      "We may also disclose information if required by law, court order, or to protect the safety of Wishing Wellness, our users, or the public.",
    ],
  },
  {
    heading: "7. Your rights and choices",
    list: [
      "You can unsubscribe from our newsletter at any time.",
      "You can ask us to see, correct, or delete the personal information we have about you by emailing support@wishingwellnesslife.com.",
      "If you are in the EU, UK, California, or another jurisdiction that grants specific data-protection rights, those rights apply to you and we will honor them.",
    ],
  },
  {
    heading: "8. Data retention & security",
    paragraphs: [
      "We keep your information only as long as we need it to run our business — typically for the life of your subscription plus a reasonable period afterward for legal and record-keeping purposes. We use commercially reasonable safeguards (encryption in transit, access controls, and reputable service providers) to protect it.",
      "No online service is 100% secure. If a data incident affects you, we will notify you and the relevant authorities as required by law.",
    ],
  },
  {
    heading: "9. Children",
    paragraphs: [
      "Wishing Wellness is intended for adults. We do not knowingly collect information from children under 13 (or the equivalent minimum age in your country). If you believe a child has given us information, please contact us and we will delete it.",
    ],
  },
  {
    heading: "10. Changes to this policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time. When we do, we will update the \"Last updated\" date at the top of this page. Material changes will be announced by email or a prominent notice on the site.",
    ],
  },
  {
    heading: "11. Contact",
    paragraphs: [
      "Questions or requests about your privacy? Email us at support@wishingwellnesslife.com and we will respond within a reasonable time (usually within two business days).",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="December 2025"
      intro="Wishing Wellness is built on trust. This Privacy Policy is written in plain English so you know exactly what we do with your information — and, more importantly, what we don't."
      sections={sections}
      testId="privacy-page"
    />
  );
}
